import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
    },
    {
        path: '/categories',
        name: 'Categories',
        component: () => import('@/views/Categories.vue'),
        meta: { title: '商品分类' }
    },
    {
        path: '/category/:id',
        name: 'Category',
        component: () => import('@/views/Category.vue'),
        meta: { title: '商品分类' }
    },
    {
        path: '/product/:id',
        name: 'Product',
        component: () => import('@/views/Product.vue'),
        meta: { title: '商品详情' }
    },
    {
        path: '/hot',
        name: 'Hot',
        component: () => import('@/views/Hot.vue'),
        meta: { title: '热门商品' }
    },
    {
        path: '/new',
        name: 'New',
        component: () => import('@/views/New.vue'),
        meta: { title: '新品上架' }
    },
    {
        path: '/search',
        name: 'Search',
        component: () => import('@/views/Search.vue'),
        meta: { title: '搜索结果' }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About.vue'),
        meta: { title: '关于我们' }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0, behavior: 'smooth' }
        }
    }
})

// 预加载重要页面
const preloadPages = [
    () => import('@/views/Categories.vue'),
    () => import('@/views/Hot.vue'),
    () => import('@/views/New.vue'),
    () => import('@/views/About.vue')
]

// 延迟预加载，避免影响首屏
setTimeout(() => {
    preloadPages.forEach(loader => {
        loader().catch(() => {
            // 忽略预加载错误
        })
    })
}, 2000)

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = `${to.meta.title} - 拾光`
    }
    next()
})

export default router
